module.exports = __webpack_public_path__ + "static/media/success-request-image.4637ac06.png";